import * as React from "react"
import {Form} from "semantic-ui-react"
import {MapState} from "./BookingDetails"
import {SaveResetButtons, SectionProps, UpdatableFormSection} from "./UpdateBookingWizard"
import {GraphQL} from "../graphql"
import {BookingGutsFragment, PromotionInput, SetBookingPromotion} from "../graphql/queries"
import {errorUnionToEither} from "../graphql/errors"

export function promotionStateToInput(state: PromotionsState): PromotionInput {
  const {promoCode, giftLoyaltyCredits} = state
  return {
    promoCode: promoCode ? promoCode : null,
    giftLoyaltyCredits,
  }
}

export interface PromotionsState {
  promoCode: string | null
  giftLoyaltyCredits: boolean
}

interface PromotionsProps {
  state: PromotionsState
  mapState: MapState<PromotionsState> | null
  disabled: boolean
  booking?: BookingGutsFragment
}

export function Promotions(props: PromotionsProps) {
  const {promoCode, giftLoyaltyCredits} = props.state
  const {disabled, mapState} = props

  if (mapState) {
    return (
      <>
        <Form.Field>
          <label>Promo or Loyalty code</label>
          <Form.Input
            placeholder="Promo or Loyalty code"
            value={promoCode || ""}
            onChange={(e, field) => {
              mapState((state) => ({...state, promoCode: field.value}))
            }}
          />
        </Form.Field>
        <Form.Field>
          <label>Gift your loyalty credits to charity?</label>
          <Form.Checkbox
            checked={giftLoyaltyCredits}
            onChange={(e, {checked}) => {
              mapState((state) => ({...state, giftLoyaltyCredits: checked || false}))
            }}
          />
        </Form.Field>
      </>
    )
  } else {
    return (
      <>
        <Form.Field>
          <label>Promo or Loyalty code</label>
          <span>{props.state.promoCode ? props.state.promoCode : <i>None</i>}</span>
        </Form.Field>
        <Form.Field>
          <label>Gift loyalty credits to charity?</label>
          <span>{props.state.giftLoyaltyCredits ? "Yes" : "No"}</span>
        </Form.Field>
      </>
    )
  }
}

interface PromotionsWidgetState {
  showPromotions: boolean
}

export class PromotionsWidget extends React.Component<PromotionsProps, PromotionsWidgetState> {
  constructor(props: PromotionsProps) {
    super(props)
    this.state = {
      showPromotions: Boolean(props.state.promoCode),
    }
  }

  render() {
    const {
      mapState,
      state: {promoCode},
      disabled,
    } = this.props
    if (this.state.showPromotions || Boolean(promoCode)) {
      return <Promotions {...this.props} />
    } else if (mapState) {
      return (
        <Form.Button
          content="Promo code and loyalty credits"
          icon="chevron right"
          labelPosition="right"
          disabled={disabled}
          onClick={(e) => {
            e.preventDefault()
            this.setState({showPromotions: true})
          }}
        />
      )
    } else {
      return null
    }
  }
}

export function PromotionsSection(props: SectionProps) {
  const state: PromotionsState = {
    promoCode: props.booking.promoCode,
    giftLoyaltyCredits: props.booking.giftLoyaltyCredits,
  }
  return (
    <UpdatableFormSection
      {...props}
      state={state}
      header="Promotions and Loyalty"
      render={(params) => {
        const {state, mapState} = params
        return (
          <Form>
            <Form.Field>
              <Promotions
                booking={props.booking}
                disabled={props.disabled}
                state={state}
                mapState={mapState}
              />
            </Form.Field>
            {mapState && (
              <Form.Group>
                <SaveResetButtons
                  {...props}
                  onSave={async () => {
                    const data = await props.modalStore.applyModal({
                      pending: ["Saving booking promotion", "Saving booking promotion.."],
                      error: (m) => ["Failed to save booking notes", m],
                      action: async () => {
                        const data = await GraphQL.mutate(SetBookingPromotion, {
                          id: props.booking.id,
                          promotion: promotionStateToInput(state),
                        })
                        return errorUnionToEither(data.setBookingPromotion)
                      },
                    })
                    return data.isRight()
                  }}
                />
              </Form.Group>
            )}
          </Form>
        )
      }}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/Promotions.tsx